export default {
  name: 'ui/toast',
  namespaced: true,
  state: {
    show: false,
    message: null,
    timeout: 3000,
  },
  mutations: {
    close(state) {
      state.show = false
    },
    setOptions(state, message) {
      state.message = message
      state.show = true
    },
  },
  actions: {
    alert({ commit }, message) {
      commit('setOptions', message)
    },
  },
}
